import { CanvasRows } from "./@types";
import { components } from "./consts";

const insert = <T>(array: Array<T>, value: T, to: number) => [
  ...array.slice(0, to),
  value,
  ...array.slice(to)
];

const findRowByComponentId = (rows: CanvasRows, id: string) => {
  const row = rows.find(r => r.components.includes(id));
  const index = rows.findIndex(r => r.components.includes(id));
  return { row, index: index < 0 ? null : index };
};

const removeFromRowById = (rows: CanvasRows, row: number, id: string) => {
  const rowsCopy = [...rows];
  const width = components[id].width;
  const containedRow = rowsCopy[row];
  containedRow.components = containedRow.components.filter(c => c !== id);
  containedRow.width -= width;
  return rowsCopy;
};

const insertIntoRows = (rows: CanvasRows, id: string) => {
  const width = components[id].width;
  const rowsCopy = [...rows];

  const availableRow = rows.findIndex(r => r.width === 50);

  const isFullWidth = width === 100;
  const canInsertHalfWidth = width === 50 && availableRow > -1;
  const isGridEmpty = !rows.length;

  const isInsertAtEnd = [isFullWidth, !canInsertHalfWidth, isGridEmpty].some(
    Boolean
  );

  if (isInsertAtEnd) {
    const component = { components: [id], width };
    return [...rowsCopy, component];
  }

  rowsCopy[availableRow].components.push(id);
  rowsCopy[availableRow].width = 100;
  return rowsCopy;
};

const swapItems = (rows: CanvasRows, id: string, over: string) =>
  rows.map(obj => {
    const comps = [...obj.components];

    const first = comps.indexOf(id);
    const second = comps.indexOf(over);

    if (first !== -1 && second !== -1) {
      [comps[first], comps[second]] = [comps[second], comps[first]];
    } else if (first !== -1) {
      comps[first] = over;
    } else if (second !== -1) {
      comps[second] = id;
    }
    return { ...obj, components: comps };
  });

export {
  findRowByComponentId,
  insert,
  insertIntoRows,
  removeFromRowById,
  swapItems
};
